export const CAR_COLORS = [
    {
        keys: ['blanco']
    },
    {
        keys: ['negro']
    },
    {
        keys: ['gris']
    },
    {
        keys: ['plata', 'plateado']
    },
    {
        keys: ['beige']
    },
    {
        keys: ['dorado']
    },
    {
        keys: ['verde']
    },
    {
        keys: ['azul']
    },
    {
        keys: ['morado']
    },
    {
        keys: ['rojo']
    },
    {
        keys: ['otro']
    },
];

export const optionsAccidentsReported = [
    {
        id: "withAccidents",
        name: "Con accidentes",
        value: true
    },
    {
        id: "withoutAccidents",
        name: "Sin accidentes",
        value: false
    }
];

export const optionsPersonalUse = [
    {
        id: "personalUse",
        name: "Uso personal",
        value: true
    },
    {
        id: "comercialUse",
        name: "Uso comercial",
        value: false
    },
];

export const optionsSoleOwner = [
    {
        id: "yes",
        name: "Si",
        value: true
    },
    {
        id: "no",
        name: "No",
        value: false
    },
];

export const translations = (status: string) => {
    if (status === "counteroffered") return "Contraoferta";
    if (status === "pause") return "Pausado";
    if (status === "pending") return "Pendiente";
    if (status === "approved") return "Aprobado";
    if (status === "cancelled") return "Cancelado";
    if (status === "rejected") return "Rechazado";
    if (status === "accepted") return "Aceptado";
    if (status === "paid") return "Pagado";
    if (status === 'processing' || status === "in_progress") return "En progreso";
    if (status === "in_evaluation") return "En evaluación";
    if (status === "conventional") return "Convencional";
    if (status === "intelligent") return "Inteligente";
    if (status === "high") return "Alta";
    if (status === "low") return "Baja";
    if (status === "medium") return "Media";
    if (status === "normal") return "Media";
    return "";
};

export const prorityTranslations = (priority: string) => {
    if (priority === "high") return "Alta";
    if (priority === "low") return "Baja";
    if (priority === "medium") return "Media";
    if (priority === "normal") return "Media";
    return "";
}

export const CONVERSATION_DEFAULT = [
    {
        text: "En base a tu criterio, aqui tienes un gran opción de SUV",
        user: "linze",
        date: "17:06 PM"
    },
    {
        text: "La Citroën Berlingo tiene un motor versátil, opciones de transmisión manual o automática y un espacioso compartimento de carga. Además, es eficiente en combustible y está equipada con tecnología de infoentretenimiento y características de seguridad avanzadas. Puede acomodar de 5 a 7 pasajeros, según la versión, y su tamaño compacto facilita la conducción en la ciudad.",
        user: "linze",
        date: "17:07 PM"
    },
    {
        text: "https://test.linze.cl/publication/655deab7836c3d8e57ad0907",
        user: "linze",
        date: "17:07 PM"
    }
];

export const DEALERSHIPS_TYPES = [
    {
        id: 'dealership',
        name: 'Concesionario',
        value: 'dealership'
    },
    {
        id: 'showroom',
        name: 'Showroom',
        value: 'showroom'
    }
];